import React, { useEffect, useRef } from "react";
import { Input } from "reactstrap";
import dayjs from "dayjs";
import { DealStatus } from "constants/Constants";
import { LoanPeriod } from "constants/Constants";

const FinanceDaysToPayInput = ({
	loanPeriod,
	daysToPay,
	editDaysToPay,
	firstDueDate,
	loanDate,
	type,
	dealId,
}) => {
	const re = /^\d{1,3}$/;
	const prevLoanPeriod = useRef(loanPeriod);

	const calculateDaysToPay = () => {
		const date1 = dayjs(loanDate);
		const date2 = dayjs(firstDueDate);

		const diff = date2.diff(date1, "day");
		if (diff) {
			editDaysToPay(diff);
		}
	};

	const daysInPeriod = LoanPeriod[loanPeriod].daysInPeriod;
	const maxDaysToPay = daysInPeriod * 2;

	useEffect(() => {
		// Only update daysToPay when loanPeriod actually changes to a different value
		if (prevLoanPeriod.current !== loanPeriod) {
			editDaysToPay(LoanPeriod[loanPeriod].daysInPeriod);
			prevLoanPeriod.current = loanPeriod;
		}
	}, [loanPeriod, editDaysToPay]);

	return (
		<Input
			type="number"
			readOnly={
				(Number(loanPeriod) === 5 || type !== DealStatus.PENDING) &&
				type !== "BHPH"
			}
			onFocus={(e) => e.target.select()}
			value={daysToPay}
			onBlur={(e) => {
				if (e.target.value === "") {
					editDaysToPay(daysInPeriod);
				}
			}}
			onChange={(e) => {
				let changed = e.target.value;
				if (changed === "") {
					editDaysToPay(daysInPeriod);
				} else if (changed.match(re)) {
					editDaysToPay(e.target.valueAsNumber);
				}
			}}
		/>
	);
};

export default FinanceDaysToPayInput;
